import { Logger, LogLevel } from "../Logger";

class ClientCache {
    private Cache?: Cache;
    private Namespace: string;

    constructor(namespace?: string) {
        this.Namespace = namespace || "prolist_v2";

        if(typeof window.caches !== "undefined") {
            window.caches.open(this.Namespace).then(cache => {
                this.Cache = cache;

                Logger.Log(LogLevel.Debug, "Cache Initialised");

                window.addEventListener('beforeunload', () => {
                    window.caches.delete(this.Namespace);
                })
            }).catch(ex => {
                Logger.Log(LogLevel.Error, "Failed to initialise cache", ex);
            });
        }
    }

    Get(request: Request): Promise<Response | undefined> {
        if(this.Cache) return this.Cache.match(request);

        return new Promise((resolve, reject) => {
            resolve(undefined);
        });
    }

    Put(request: Request, response: Response) {
        if(this.Cache) this.Cache.put(request, response);
    }
}

export { ClientCache }